document?.addEventListener('DOMContentLoaded', function () {
    const root = document.querySelector('.ff-pdp-delivery') || document.querySelector('.default-delivery-time');
    const appDatesEl = document.querySelector('[data-ff-delivery-dates]');
    const vendorDatesEl = document.querySelector('[data-ff-vendor-dates]');
    const productShippingEl = document.querySelector('[data-ff-product-shipping]') || document.querySelector('.product-shipping-info');

    function hasProductShippingInfo() {
        const flagEl = document.getElementById('ff-has-product-shipping-info');
        if (flagEl) {
            try {
                return JSON.parse(flagEl.textContent || 'false') === true;
            } catch (e) {
                // fall through
            }
        }
        if (!productShippingEl) return false;
        const content = productShippingEl.querySelector('.product-shipping-info__content');
        const text = (content?.innerText || content?.textContent || '').trim();
        return text.length > 0;
    }

    function hasVendorShipping() {
        const flag = root?.getAttribute('data-has-vendor-shipping');
        if (flag === 'true') return true;
        if (flag === 'false') return false;
        const deliveryTime = root?.getAttribute('data-delivery-time');
        return !!(deliveryTime && deliveryTime.trim().length);
    }

    /**
     * source: 'app' | 'vendor' | 'product' | 'none'
     * Green widget only for app (specific-date / fresh). White widget for vendor.
     */
    function showSource(source) {
        if (appDatesEl) {
            appDatesEl.style.display = source === 'app' ? 'block' : 'none';
        }
        if (vendorDatesEl) {
            vendorDatesEl.style.display = source === 'vendor' ? 'block' : 'none';
        }
        if (productShippingEl) {
            productShippingEl.style.display = source === 'product' ? 'flex' : 'none';
        }
    }

    function getVariantRulesMap() {
        const el = document.getElementById('ff-delivery-variant-rules');
        if (!el) return {};
        try {
            return JSON.parse(el.textContent || '{}') || {};
        } catch (e) {
            return {};
        }
    }

    function getSelectedVariantId() {
        const fromWidget = root?.getAttribute('data-variant-id');
        const idInput = document.querySelector('form[action*="/cart/add"] [name="id"], form[action="/cart/add"] [name="id"], [data-product-form] [name="id"]');
        if (idInput && idInput.value) return String(idInput.value);
        if (fromWidget) return String(fromWidget);
        return null;
    }

    function getVendorDeliveryRange() {
        let deliveryTime = root?.getAttribute('data-delivery-time');
        if (!deliveryTime || !deliveryTime.trim().length) {
            return null;
        }
        const parts = deliveryTime.split('-');
        let initialDay = parseInt(parts[0], 10);
        let finalDay = parseInt(parts[1], 10);
        if (!Number.isFinite(initialDay)) return null;
        if (!Number.isFinite(finalDay)) finalDay = initialDay;
        if (finalDay < initialDay) finalDay = initialDay;
        return { initialDay, finalDay };
    }

    function parseFixedDates(raw) {
        if (!raw) return [];
        if (Array.isArray(raw)) return raw.map(String).filter(Boolean);
        if (typeof raw === 'string') {
            try {
                const parsed = JSON.parse(raw);
                if (Array.isArray(parsed)) return parsed.map(String).filter(Boolean);
            } catch (e) {
                return raw.split(',').map(s => s.trim()).filter(Boolean);
            }
        }
        return [];
    }

    /**
     * True only when the variant has delivery rules configured in the Calendar app.
     * Those products are "fresh" / specific-date eligible → green widget.
     */
    function getConfiguredAppRule() {
        try {
            const variantId = getSelectedVariantId();
            const rules = getVariantRulesMap();
            if (!variantId || !rules[variantId]) return null;

            const rule = rules[variantId] || {};
            const mode = String(rule.mode || '').toLowerCase();
            const fixedDates = parseFixedDates(rule.fixed_dates);
            const hasMode = mode === 'standard' || mode === 'fixed_dates';
            const hasMin = !(rule.min_days === null || rule.min_days === undefined || rule.min_days === '');
            const hasFixed = fixedDates.length > 0;

            // No metafields configured → not eligible for green widget
            if (!hasMode && !hasMin && !hasFixed) return null;
            // mode alone empty string with null min and no fixed → not configured
            if (!mode && !hasMin && !hasFixed) return null;

            if (mode === 'fixed_dates' && hasFixed) {
                return { mode: 'fixed_dates', fixed_dates: fixedDates };
            }

            if (hasMin) {
                const minDays = parseInt(rule.min_days, 10);
                if (!Number.isFinite(minDays) || minDays < 0) return null;
                return { mode: 'standard', min_days: minDays };
            }

            // mode=standard was explicitly saved (even with min_days 0)
            if (mode === 'standard') {
                return { mode: 'standard', min_days: 0 };
            }

            return null;
        } catch (e) {
            console.error('Delivery date app rule failed, falling back:', e);
            return null;
        }
    }

    function calculateDatesFromVendorSettings(ukHolidays) {
        const range = getVendorDeliveryRange();
        if (!range) return null;

        let businessDaysToAdd = range.finalDay - range.initialDay;
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        let fromDateCart = adjustDeliveryDate(addDays(today, range.initialDay), ukHolidays);
        let toDateCart = new Date(fromDateCart);

        while (businessDaysToAdd > 0) {
            toDateCart = getNextDay(toDateCart);
            if (!isSunday(toDateCart) && !isMonday(toDateCart) && !isUKHoliday(toDateCart, ukHolidays)) {
                businessDaysToAdd--;
            }
        }

        return { fromDateCart, toDateCart };
    }

    function parseISOToLocalDate(iso) {
        const parts = String(iso).split('-');
        if (parts.length !== 3) return null;
        return new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    }

    /**
     * App rule dates:
     * - standard → range (n and n+1), skipping Sun / Mon / UK holidays
     * - fixed_dates → exact next fixed date (no range, no blackout shift)
     */
    function calculateDatesFromAppRule(appRule, ukHolidays) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (appRule.mode === 'fixed_dates') {
            const todayISO = formatDateForHolidayCheck(today);
            const upcoming = appRule.fixed_dates
                .map(String)
                .filter(iso => iso >= todayISO)
                .sort();

            if (upcoming.length === 0) return null;

            // Use the exact configured date — do not shift for Sun/Mon/holidays
            const fixedDate = parseISOToLocalDate(upcoming[0]);
            if (!fixedDate) return null;

            return { mode: 'fixed', fixedDate };
        }

        const fromDateCart = adjustDeliveryDate(addDays(today, appRule.min_days), ukHolidays);
        const toDateCart = nextAvailableDay(fromDateCart, ukHolidays);
        return { mode: 'range', fromDateCart, toDateCart };
    }

    function setAppCopyMode(mode) {
        const rangeCopy = document.querySelector('[data-ff-app-copy="range"]');
        const fixedCopy = document.querySelector('[data-ff-app-copy="fixed"]');
        if (rangeCopy) rangeCopy.style.display = mode === 'range' ? '' : 'none';
        if (fixedCopy) fixedCopy.style.display = mode === 'fixed' ? '' : 'none';
    }

    function insertAppDates(appDates) {
        if (!appDates) return;

        if (appDates.mode === 'fixed') {
            setAppCopyMode('fixed');
            const fixedDateEl = document.getElementById('fixedDate');
            if (fixedDateEl) fixedDateEl.innerHTML = formatDate(appDates.fixedDate);
            return;
        }

        setAppCopyMode('range');
        const fromDateEl = document.getElementById('fromDate');
        const toDateEl = document.getElementById('toDate');
        if (fromDateEl) fromDateEl.innerHTML = formatDate(appDates.fromDateCart);
        if (toDateEl) toDateEl.innerHTML = formatDate(appDates.toDateCart);
    }

    function insertVendorDates(fromDateCart, toDateCart) {
        const fromDateEl = document.getElementById('vendorFromDate');
        const toDateEl = document.getElementById('vendorToDate');
        if (fromDateEl) fromDateEl.innerHTML = formatDate(fromDateCart);
        if (toDateEl) toDateEl.innerHTML = formatDate(toDateCart);
    }

    /**
     * Cascade:
     * 1. App rules → green widget (specific date delivery)
     * 2. Vendor theme settings → white widget
     * 3. Product Shipping Info (Admin)
     */
    function calculateAndInsertDates(ukHolidays) {
        try {
            const appRule = getConfiguredAppRule();
            if (appRule) {
                const appDates = calculateDatesFromAppRule(appRule, ukHolidays);
                if (appDates) {
                    insertAppDates(appDates);
                    showSource('app');
                    return;
                }
            }
        } catch (e) {
            console.error('Delivery date app calculation failed, falling back:', e);
        }

        if (hasVendorShipping()) {
            try {
                const vendorDates = calculateDatesFromVendorSettings(ukHolidays);
                if (vendorDates) {
                    insertVendorDates(vendorDates.fromDateCart, vendorDates.toDateCart);
                    showSource('vendor');
                    return;
                }
            } catch (e) {
                console.error('Vendor shipping calculation failed, falling back:', e);
            }
        }

        if (hasProductShippingInfo()) {
            showSource('product');
            return;
        }

        showSource('none');
    }

    function adjustDeliveryDate(date, ukHolidays) {
        let adjustedDate = new Date(date);
        let adjustmentCount = 0;
        while (isSunday(adjustedDate) || isMonday(adjustedDate) || isUKHoliday(adjustedDate, ukHolidays)) {
            adjustedDate = getNextDay(adjustedDate);
            adjustmentCount++;
            if (adjustmentCount > 10) break;
        }
        return adjustedDate;
    }

    function nextAvailableDay(date, ukHolidays) {
        return adjustDeliveryDate(getNextDay(date), ukHolidays);
    }

    function formatDate(date) {
        const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const day = date.getDate();
        const daySuffix = day === 1 || day === 21 || day === 31 ? 'st' : day === 2 || day === 22 ? 'nd' : day === 3 || day === 23 ? 'rd' : 'th';
        return `${days[date.getDay()]} ${months[date.getMonth()]} ${day}${daySuffix}`;
    }

    function addDays(date, days) {
        const result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    function getNextDay(date) {
        return addDays(date, 1);
    }

    function isSunday(date) {
        return date.getDay() === 0;
    }

    function isMonday(date) {
        return date.getDay() === 1;
    }

    function formatDateForHolidayCheck(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }

    function isUKHoliday(date, ukHolidays) {
        return (ukHolidays || []).includes(formatDateForHolidayCheck(date));
    }

    async function getUKHolidays(year) {
        try {
            const response = await fetch(`https://date.nager.at/api/v2/publicholidays/${year}/gb`);
            const holidaysData = await response.json();
            return holidaysData.map(holiday => holiday.date);
        } catch (error) {
            console.error('Error getting UK holidays:', error);
            return [];
        }
    }

    let ukHolidaysCache = null;

    function refreshDeliveryMessage() {
        if (ukHolidaysCache) {
            calculateAndInsertDates(ukHolidaysCache);
        }
    }

    function syncVariantIdFromForm() {
        if (!root) return;
        const idInput = document.querySelector('form[action*="/cart/add"] [name="id"], form[action="/cart/add"] [name="id"], [data-product-form] [name="id"]');
        if (idInput && idInput.value) {
            root.setAttribute('data-variant-id', String(idInput.value));
        }
    }

    const currentYear = new Date().getFullYear();
    getUKHolidays(currentYear).then(ukHolidays => {
        ukHolidaysCache = ukHolidays;
        syncVariantIdFromForm();
        refreshDeliveryMessage();
    });

    document.addEventListener('change', function (e) {
        const target = e.target;
        if (!target || !target.matches) return;
        const isVariantControl =
            target.matches('.variant-button-wrap input[type=radio]') ||
            target.matches('.variant-wrapper input[type=radio]') ||
            target.matches('[data-variant-input]') ||
            target.matches('form[action*="/cart/add"] [name="id"]') ||
            target.matches('[name="id"]');
        if (!isVariantControl) return;
        syncVariantIdFromForm();
        refreshDeliveryMessage();
    });

    const idInput = document.querySelector('form[action*="/cart/add"] [name="id"], form[action="/cart/add"] [name="id"]');
    if (idInput && typeof MutationObserver !== 'undefined') {
        const observer = new MutationObserver(function () {
            syncVariantIdFromForm();
            refreshDeliveryMessage();
        });
        observer.observe(idInput, { attributes: true, attributeFilter: ['value'] });
        idInput.addEventListener('change', function () {
            syncVariantIdFromForm();
            refreshDeliveryMessage();
        });
    }
});
